export const regionals = `query {
    regionals {
        kmatID
        name
      }
  }`
